// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!./resize.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --space-xss: 0.25rem;
    --space-xs: 0.5rem;
    --space-sm: 0.75rem;
    --space-md: 1.25rem;
    --space-lg: 2rem;
    --space-xl: 3.25rem;
    --space-xxl: 5.25rem;
}

:root {
    --gray-100: #f7fafc;
    --gray-200: #edf2f7;
    --gray-300: #e2e8f0;
    --gray-400: #cbd5e0;
    --gray-500: #a0aec0;
    --gray-600: #718096;
    --gray-700: #4a5568;
    --gray-800: #2d3748;
    --gray-900: #1a202c;
    --box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
    --highlight: rgba(255, 255, 153, 1);
}

/** Reset / Set defaults */
.pgnvjs {
    font-family: "Segoe UI", Roboto, Ubuntu, "Helvetica Neue", Oxygen, Cantarell, sans-serif;
    margin: 0;
}
.pgnvjs ul,
.pgnvjs ol {
    list-style: none;
    margin: 0;
    padding: 0;
}
.pgnvjs:focus {
    /* The following suppresses the outline of the element that has the focus. Only when
       that focus is set, the keyboard mappings work. You may of course enable the outline
       for debugging purposes. */
    outline: 0;
}

.pgnvjs .moves {
    overflow-y: auto;
}

.pgnvjs .buttons {
    display: flex;
}

/** Layout styles: View */
.pgnvjs.layout-left .games,
.pgnvjs.layout-right .games {
    grid-column: 1 / 3;
}

.pgnvjs.layout-left,
.pgnvjs.layout-right {
    display: grid;
    gap: 0.5em;
    grid-template-columns: auto auto;
    grid-template-rows: 40px auto minmax(auto, 1fr) 50px;
}

.pgnvjs.layout-left .error,
.pgnvjs.layout-right .error {
    grid-column: 1 / 3;
    grid-row: 2 / 3;
}

.pgnvjs.layout-left .outerBoard,
.pgnvjs.layout-left .outerBoard,
.pgnvjs.layout-right .outerBoard,
.pgnvjs.layout-right .outerBoard {
    grid-row: 3 / 4;
}

.pgnvjs.layout-left .outerBoard {
    grid-column: 1 / 2;
}

.pgnvjs.layout-right .outerBoard {
    grid-column: 2 / 3;
}

.pgnvjs.layout-left .buttons,
.pgnvjs.layout-right .buttons {
    place-self: center;
    grid-row: 4 / 5;
}

.pgnvjs.viewMode.layout-left .buttons,
.pgnvjs.editMode.layout-right .buttons {
    grid-column: 1 / 2;
}

.pgnvjs.viewMode.layout-right .buttons,
.pgnvjs.editMode.layout-left .buttons {
    grid-column: 2 / 3;
}

.pgnvjs.viewMode.layout-left .moves,
.pgnvjs.viewMode.layout-right .moves {
    grid-row: 3 / 5;
    overflow-y: auto;
    overflow-x: hidden;
}

.pgnvjs.editMode.layout-left .moves,
.pgnvjs.editMode.layout-right .moves {
    grid-row: 3/4;
    overflow-y: auto;
    overflow-x: hidden;
}

.pgnvjs.editMode.layout-left .edit {
    grid-column: 1 / 2;
    grid-row: 4 / 5;
}

.pgnvjs.editMode.layout-top .edit {
    grid-column: 1 / 2;
    grid-row: 6 / 7;
}

.pgnvjs.layout-left .moves {
    grid-column: 2 / 3;
}

.pgnvjs.layout-right .moves {
    grid-column: 1 / 2;
}

/* layout top / bottom */
.pgnvjs.layout-top {
    display: grid;
    /*gap: 0.5em;   Why should I use a gap all the time? At least at the top of the board it is strange ...*/
    grid-template-columns: auto;
    grid-template-rows: auto minmax(auto, 1fr) 50px auto;
}

.pgnvjs.layout-bottom {
    display: grid;
    /*gap: 0.5em;*/
    grid-template-columns: auto;
    grid-template-rows: auto auto minmax(auto, 400px) 50px;
}

.pgnvjs.layout-top .error,
.pgnvjs.layout-bottom .error {
    grid-row: 2/3;
}

.pgnvjs.layout-top .outerBoard {
    grid-row: 3/4;
}

.pgnvjs.layout-bottom .outerBoard {
    grid-row: 4/5;
}

.pgnvjs.layout-top .buttons {
    place-self: center;
    grid-row: 4/5;
}

.pgnvjs.layout-bottom .buttons {
    place-self: center;
    grid-row: 5/6;
}

.pgnvjs.layout-top .moves,
.pgnvjs.layout-bottom .moves {
    overflow: auto;
}

.pgnvjs.layout-top .moves {
    grid-row: 5/6;
}

.pgnvjs.layout-bottom .moves {
    grid-row: 3/4;
}

/** Print mode */
.pgnvjs.layout-top.printMode {
    gap: 0;
    grid-template-columns: auto;
    grid-template-rows: auto;
}

.pgnvjs.layout-top.printMode .moves {
    width: 110%;
}

.pgnvjs.printMode > .outerBoard {
    display: none;
}

/** Board mode */
.pgnvjs.layout-top.boardMode {
    gap: 0;
    grid-template-columns: auto;
    grid-template-rows: auto;
}

/** Other styling ... */

.pgnvjs .fen {
    width: calc(100% - 8px);
    height: 35px;
    margin: 0;
    padding: var(--space-xss);
    font-family: monospace;
}

.pgnvjs div.error {
    color: red;
}

.pgnvjs div.buttons > .pgnvbutton,
.pgnvjs div.edit > .pgnvbutton {
    color: var(--gray-600);
    background-color: var(--gray-100);
    margin: 0.24rem;
    padding: 4px;
    border: solid var(--gray-300) 1px;
    border-radius: 4px;
}

.pgnvjs div.buttons > .pgnvbutton.selected,
.pgnvjs div.edit > .pgnvbutton.selected,
.pgnvjs .nagMenu.selected {
    color: var(--gray-100);
    background-color: var(--gray-700);
}

.pgnvjs div.buttons > .pgnvbutton:hover,
.pgnvjs div.edit > .pgnvbutton:hover {
    cursor: pointer;
    border: solid var(--gray-700) 1px;
}

.pgnvjs div.nagMenu {
    border: 1px grey dotted;
    display: none;
    width: 500px;
}

.pgnvjs div.buttons > .pgnvbutton.gray,
.pgnvjs div.buttons > .pgnvbutton.gray:hover {
    opacity: 0.5;
    cursor: default;
    border: solid var(--gray-300) 1px;
}

.pgnvjs div.nagMenu a,
.pgnvjs .nagMenu i {
    text-decoration: none;
    font-style: unset;
    /*text-align: center;*/
}

.pgnvjs div.nagMove,
.pgnvjs div.nagObservation,
.pgnvjs div.nagPosition {
    display: flex;
    flex-direction: column;
    flex-basis: 33.3%;
    /*text-align: left;*/
    flex-wrap: wrap;
}
.pgnvjs .nagMove i,
.pgnvjs .nagPosition i,
.pgnvjs .nagObservation i {
    display: flex;
    cursor: pointer;
    align-items: center;
    justify-content: left;
    margin: var(--space-xss);
}

.pgnvjs .nagMove i::before,
.pgnvjs .nagPosition i::before,
.pgnvjs .nagObservation i::before {
    content: attr(data-symbol);
    font-style: normal;
    width: var(--space-md);
    justify-content: center;
    align-items: center;
    /*width: 30px;*/
}

.pgnvjs a.active i::before {
    background: var(--gray-700) !important;
    color: var(--gray-100) !important;
}

.pgnvjs a.active i::before i:hover {
    background: var(--gray-100) !important;
    color: var(--gray-700) !important;
}

.pgnvjs .nagMove i:hover,
.pgnvjs .nagPosition i:hover,
.pgnvjs .nagObservation i:hover {
    background: var(--gray-700);
    color: var(--gray-100);
}

.pgnvjs textarea.textpgn {
    padding: 2px;
    border: 1px solid grey;
    width: 96%;
    height: 100px;
    font-family: monospace;
}

.ui-widget {
    font-size: 1em;
}

.pgnvjs div.commentRadio label {
    display: inline;
}
.pgnvjs div.comment > textarea.comment {
    font-family: monospace;
    width: 96%;
    height: 50px;
    padding: 2px;
}

.pgnvjs .moves.inline .filler {
    display: none;
}

.pgnvjs .moves.inline move-number.filler {
    display: inline;
}

.pgnvjs .moves.list {
    display: flex;
    flex-flow: row wrap;
    align-content: flex-start;
    overflow-x: hidden;
    width: 100%;
}

.pgnvjs .moves.list > .result {
    display: flex;
    flex: 0 0 100%;
    justify-content: center;
    margin-top: 0.5em; /* Add some spacing from moves above */
    white-space: nowrap;
}

.pgnvjs .moves.list > move,
.pgnvjs .moves.list .move.filler {
    flex: 0 0 35%;
    display: flex;
    /*padding: 0 0.3em;*/
    white-space: nowrap;
}

.pgnvjs .moves > move,
.result {
    display: inline-block;
}

.pgnvjs .variation,
.pgnvjs .variation > .moveNumber,
.pgnvjs .variation > move.var {
    white-space: normal;
}

.pgnvjs .moves.list > move-number {
    flex: 0 0 15%;
    justify-content: center;
    display: flex;
    border-right: 1px solid var(--gray-300);
    background: var(--gray-100);
}

.pgnvjs .moves a {
    text-decoration: underline;
}

.pgnvjs .moves move san.yellow {
    /*background-color: rgba(255, 255, 153, 1.0);*/
    color: var(--gray-800);
    background-color: var(--highlight);
}

.pgnvjs .moves move san {
    text-decoration: none;
    padding: 0 0.2rem;
}

.pgnvjs .moves move san:hover {
    /*border: 1px yellow dotted;*/
    background-color: var(--highlight);
    cursor: crosshair;
}

.pgnvjs .moves move nag::before {
    content: attr(data-value);
}

.pgnvjs .moves move nag.hideaddcontent::before {
    content: "";
}

/*.pgnvjs .moves move nag[data-value="\$11"]::before {*/
/*    content: "=";*/
/*}*/

.pgnvjs .moves,
.pgnvjs select.games {
    color: black;
    font-weight: 700;
    line-height: normal;
}

.pgnvjs .moves .variation move.var,
.pgnvjs .moves .variation move-number {
    font-size: 97%;
    font-weight: 500;
}

.pgnvjs .moves .variation .variation move.var,
.pgnvjs .moves .variation .variation move-number {
    font-size: 95%;
    font-weight: 300;
}

.pgnvjs.moves .variation {
    display: inline-block;
    margin: 0 6px;
}

.pgnvjs .moves.list .variations {
    flex: 0 0 100%;
    flex-wrap: wrap;
    display: flex;
    margin: 0;
    background: var(--gray-100);
    border-top: 1px solid var(--gray-300);
    border-bottom: 1px solid var(--gray-300);
}

.pgnvjs .moves.list .variation {
    flex: 0 0 90%;
    display: block;
    margin: 0 20px;
}

.pgnvjs .moves .variation:before {
    content: " ( ";
}

.pgnvjs .moves .variation .variation:before {
    content: " ( ";
}

.pgnvjs .moves .variation .variation {
    margin: 0 6px;
}

.pgnvjs .moves .variation .variation:after {
    content: " ) ";
}

.pgnvjs .moves .variation:after {
    content: " ) ";
}

.pgnvjs .moves .comment,
.pgnvjs .moves.list > .variation > .comment {
    color: var(--gray-600);
    font-weight: 500;
    display: inline;
}

.pgnvjs .moves.list > .comment {
    flex: 0 0 100%;
    display: flex;
    background: var(--gray-100);
    border-top: 1px solid var(--gray-300);
    border-bottom: 1px solid var(--gray-300);
    /* padding: 5px; */
}

.pgnvjs .moves move .comment.timeTiny {
    font-weight: 300;
    font-size: 60%;
}

.pgnvjs .moves move .comment.timeLarge {
}

.pgnvjs .moves move .timeNormal {
    font-weight: 400;
    font-size: 80%;
}

/*
puzzle mode
*/

.pgnvjs textarea.hints {
    grid-row: 6/6;
    display: flex;
    font-family: monospace;
    width: 96%;
    height: 100px;
    padding: 2px;
}

/**
  CHESSGROUND changes.
  */

.pgnvjs .cg-wrap coords.ranks {
    top: -8px;
    right: -4px;
    left: initial;
}

/*
.cg-wrap coords {
    font-size: 16px;
}
*/

.pgnvjs .cg-wrap coords.files {
    bottom: 2px;
    left: 16px;
    /*text-transform: initial;*/
}

.pgnvjs .cg-wrap.orientation-white coords.ranks coord:nth-child(2n),
.pgnvjs .cg-wrap.orientation-white coords.files coord:nth-child(2n),
.pgnvjs .cg-wrap.orientation-black coords.ranks coord:nth-child(2n + 1),
.pgnvjs .cg-wrap.orientation-black coords.files coord:nth-child(2n + 1) {
    color: initial;
}

.pgnvjs .cg-wrap.orientation-black coords.ranks coord:nth-child(2n),
.pgnvjs .cg-wrap.orientation-black coords.files coord:nth-child(2n),
.pgnvjs .cg-wrap.orientation-white coords.ranks coord:nth-child(2n + 1),
.pgnvjs .cg-wrap.orientation-white coords.files coord:nth-child(2n + 1) {
    color: initial;
}

/* colorMarker */

.pgnvjs .colorMarker {
    width: 20px;
    height: 20px;
    border-color: black;
    border-width: 2px;
    border-style: double;
    margin-left: 50px;
    align-self: center;
    box-shadow:
        0 4px 8px 0 rgba(0, 0, 0, 0.2),
        0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.pgnvjs .colorMarker.circle {
    border-radius: 20px;
}

.pgnvjs .colorMarker.circle-big {
    border-radius: 40px;
    width: 40px;
    height: 40px;
}

.pgnvjs .colorMarker.circle-small {
    border-radius: 10px;
    width: 10px;
    height: 10px;
}

.pgnvjs .colorMarker.cm-black {
    background-color: black;
}

.pgnvjs .colorMarker.cm-white {
    background-color: white;
}

.pgnvjs .colorMarker.cm-big {
    width: 40px;
    height: 40px;
}

.pgnvjs .colorMarker.cm-small {
    width: 10px;
    height: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/css/pgnvjs.css"],"names":[],"mappings":"AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,6EAA6E;IAC7E,mCAAmC;AACvC;;AAEA,0BAA0B;AAC1B;IACI,wFAAwF;IACxF,SAAS;AACb;AACA;;IAEI,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;AACA;IACI;;gCAE4B;IAC5B,UAAU;AACd;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA,yBAAyB;AACzB;;IAEI,kBAAkB;AACtB;;AAEA;;IAEI,aAAa;IACb,UAAU;IACV,gCAAgC;IAChC,oDAAoD;AACxD;;AAEA;;IAEI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;;;;IAII,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;IAEI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;;IAEI,aAAa;IACb,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA,wBAAwB;AACxB;IACI,aAAa;IACb,wGAAwG;IACxG,2BAA2B;IAC3B,oDAAoD;AACxD;;AAEA;IACI,aAAa;IACb,cAAc;IACd,2BAA2B;IAC3B,sDAAsD;AAC1D;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA,gBAAgB;AAChB;IACI,MAAM;IACN,2BAA2B;IAC3B,wBAAwB;AAC5B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA,gBAAgB;AAChB;IACI,MAAM;IACN,2BAA2B;IAC3B,wBAAwB;AAC5B;;AAEA,uBAAuB;;AAEvB;IACI,uBAAuB;IACvB,YAAY;IACZ,SAAS;IACT,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,UAAU;AACd;;AAEA;;IAEI,sBAAsB;IACtB,iCAAiC;IACjC,eAAe;IACf,YAAY;IACZ,iCAAiC;IACjC,kBAAkB;AACtB;;AAEA;;;IAGI,sBAAsB;IACtB,iCAAiC;AACrC;;AAEA;;IAEI,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,YAAY;AAChB;;AAEA;;IAEI,YAAY;IACZ,eAAe;IACf,iCAAiC;AACrC;;AAEA;;IAEI,qBAAqB;IACrB,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;;;IAGI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;AACnB;AACA;;;IAGI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,qBAAqB;IACrB,wBAAwB;AAC5B;;AAEA;;;IAGI,0BAA0B;IAC1B,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,sCAAsC;IACtC,iCAAiC;AACrC;;AAEA;IACI,sCAAsC;IACtC,iCAAiC;AACrC;;AAEA;;;IAGI,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,UAAU;IACV,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;AACA;IACI,sBAAsB;IACtB,UAAU;IACV,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,cAAc;IACd,uBAAuB;IACvB,iBAAiB,EAAE,sCAAsC;IACzD,mBAAmB;AACvB;;AAEA;;IAEI,aAAa;IACb,aAAa;IACb,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;;;IAGI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,aAAa;IACb,uCAAuC;IACvC,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,8CAA8C;IAC9C,sBAAsB;IACtB,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,6BAA6B;IAC7B,kCAAkC;IAClC,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;AACf;;AAEA,sDAAsD;AACtD,oBAAoB;AACpB,IAAI;;AAEJ;;IAEI,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;;IAEI,cAAc;IACd,gBAAgB;AACpB;;AAEA;;IAEI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,aAAa;IACb,SAAS;IACT,2BAA2B;IAC3B,qCAAqC;IACrC,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,2BAA2B;IAC3B,qCAAqC;IACrC,wCAAwC;IACxC,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;AACA;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;;CAEC;;AAED;IACI,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,aAAa;IACb,YAAY;AAChB;;AAEA;;GAEG;;AAEH;IACI,SAAS;IACT,WAAW;IACX,aAAa;AACjB;;AAEA;;;;CAIC;;AAED;IACI,WAAW;IACX,UAAU;IACV,2BAA2B;AAC/B;;AAEA;;;;IAII,cAAc;AAClB;;AAEA;;;;IAII,cAAc;AAClB;;AAEA,gBAAgB;;AAEhB;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB,iBAAiB;IACjB,kBAAkB;IAClB;;wCAEoC;AACxC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB","sourcesContent":["@import \"resize.css\";\n\n:root {\n    --space-xss: 0.25rem;\n    --space-xs: 0.5rem;\n    --space-sm: 0.75rem;\n    --space-md: 1.25rem;\n    --space-lg: 2rem;\n    --space-xl: 3.25rem;\n    --space-xxl: 5.25rem;\n}\n\n:root {\n    --gray-100: #f7fafc;\n    --gray-200: #edf2f7;\n    --gray-300: #e2e8f0;\n    --gray-400: #cbd5e0;\n    --gray-500: #a0aec0;\n    --gray-600: #718096;\n    --gray-700: #4a5568;\n    --gray-800: #2d3748;\n    --gray-900: #1a202c;\n    --box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\n    --highlight: rgba(255, 255, 153, 1);\n}\n\n/** Reset / Set defaults */\n.pgnvjs {\n    font-family: \"Segoe UI\", Roboto, Ubuntu, \"Helvetica Neue\", Oxygen, Cantarell, sans-serif;\n    margin: 0;\n}\n.pgnvjs ul,\n.pgnvjs ol {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n}\n.pgnvjs:focus {\n    /* The following suppresses the outline of the element that has the focus. Only when\n       that focus is set, the keyboard mappings work. You may of course enable the outline\n       for debugging purposes. */\n    outline: 0;\n}\n\n.pgnvjs .moves {\n    overflow-y: auto;\n}\n\n.pgnvjs .buttons {\n    display: flex;\n}\n\n/** Layout styles: View */\n.pgnvjs.layout-left .games,\n.pgnvjs.layout-right .games {\n    grid-column: 1 / 3;\n}\n\n.pgnvjs.layout-left,\n.pgnvjs.layout-right {\n    display: grid;\n    gap: 0.5em;\n    grid-template-columns: auto auto;\n    grid-template-rows: 40px auto minmax(auto, 1fr) 50px;\n}\n\n.pgnvjs.layout-left .error,\n.pgnvjs.layout-right .error {\n    grid-column: 1 / 3;\n    grid-row: 2 / 3;\n}\n\n.pgnvjs.layout-left .outerBoard,\n.pgnvjs.layout-left .outerBoard,\n.pgnvjs.layout-right .outerBoard,\n.pgnvjs.layout-right .outerBoard {\n    grid-row: 3 / 4;\n}\n\n.pgnvjs.layout-left .outerBoard {\n    grid-column: 1 / 2;\n}\n\n.pgnvjs.layout-right .outerBoard {\n    grid-column: 2 / 3;\n}\n\n.pgnvjs.layout-left .buttons,\n.pgnvjs.layout-right .buttons {\n    place-self: center;\n    grid-row: 4 / 5;\n}\n\n.pgnvjs.viewMode.layout-left .buttons,\n.pgnvjs.editMode.layout-right .buttons {\n    grid-column: 1 / 2;\n}\n\n.pgnvjs.viewMode.layout-right .buttons,\n.pgnvjs.editMode.layout-left .buttons {\n    grid-column: 2 / 3;\n}\n\n.pgnvjs.viewMode.layout-left .moves,\n.pgnvjs.viewMode.layout-right .moves {\n    grid-row: 3 / 5;\n    overflow-y: auto;\n    overflow-x: hidden;\n}\n\n.pgnvjs.editMode.layout-left .moves,\n.pgnvjs.editMode.layout-right .moves {\n    grid-row: 3/4;\n    overflow-y: auto;\n    overflow-x: hidden;\n}\n\n.pgnvjs.editMode.layout-left .edit {\n    grid-column: 1 / 2;\n    grid-row: 4 / 5;\n}\n\n.pgnvjs.editMode.layout-top .edit {\n    grid-column: 1 / 2;\n    grid-row: 6 / 7;\n}\n\n.pgnvjs.layout-left .moves {\n    grid-column: 2 / 3;\n}\n\n.pgnvjs.layout-right .moves {\n    grid-column: 1 / 2;\n}\n\n/* layout top / bottom */\n.pgnvjs.layout-top {\n    display: grid;\n    /*gap: 0.5em;   Why should I use a gap all the time? At least at the top of the board it is strange ...*/\n    grid-template-columns: auto;\n    grid-template-rows: auto minmax(auto, 1fr) 50px auto;\n}\n\n.pgnvjs.layout-bottom {\n    display: grid;\n    /*gap: 0.5em;*/\n    grid-template-columns: auto;\n    grid-template-rows: auto auto minmax(auto, 400px) 50px;\n}\n\n.pgnvjs.layout-top .error,\n.pgnvjs.layout-bottom .error {\n    grid-row: 2/3;\n}\n\n.pgnvjs.layout-top .outerBoard {\n    grid-row: 3/4;\n}\n\n.pgnvjs.layout-bottom .outerBoard {\n    grid-row: 4/5;\n}\n\n.pgnvjs.layout-top .buttons {\n    place-self: center;\n    grid-row: 4/5;\n}\n\n.pgnvjs.layout-bottom .buttons {\n    place-self: center;\n    grid-row: 5/6;\n}\n\n.pgnvjs.layout-top .moves,\n.pgnvjs.layout-bottom .moves {\n    overflow: auto;\n}\n\n.pgnvjs.layout-top .moves {\n    grid-row: 5/6;\n}\n\n.pgnvjs.layout-bottom .moves {\n    grid-row: 3/4;\n}\n\n/** Print mode */\n.pgnvjs.layout-top.printMode {\n    gap: 0;\n    grid-template-columns: auto;\n    grid-template-rows: auto;\n}\n\n.pgnvjs.layout-top.printMode .moves {\n    width: 110%;\n}\n\n.pgnvjs.printMode > .outerBoard {\n    display: none;\n}\n\n/** Board mode */\n.pgnvjs.layout-top.boardMode {\n    gap: 0;\n    grid-template-columns: auto;\n    grid-template-rows: auto;\n}\n\n/** Other styling ... */\n\n.pgnvjs .fen {\n    width: calc(100% - 8px);\n    height: 35px;\n    margin: 0;\n    padding: var(--space-xss);\n    font-family: monospace;\n}\n\n.pgnvjs div.error {\n    color: red;\n}\n\n.pgnvjs div.buttons > .pgnvbutton,\n.pgnvjs div.edit > .pgnvbutton {\n    color: var(--gray-600);\n    background-color: var(--gray-100);\n    margin: 0.24rem;\n    padding: 4px;\n    border: solid var(--gray-300) 1px;\n    border-radius: 4px;\n}\n\n.pgnvjs div.buttons > .pgnvbutton.selected,\n.pgnvjs div.edit > .pgnvbutton.selected,\n.pgnvjs .nagMenu.selected {\n    color: var(--gray-100);\n    background-color: var(--gray-700);\n}\n\n.pgnvjs div.buttons > .pgnvbutton:hover,\n.pgnvjs div.edit > .pgnvbutton:hover {\n    cursor: pointer;\n    border: solid var(--gray-700) 1px;\n}\n\n.pgnvjs div.nagMenu {\n    border: 1px grey dotted;\n    display: none;\n    width: 500px;\n}\n\n.pgnvjs div.buttons > .pgnvbutton.gray,\n.pgnvjs div.buttons > .pgnvbutton.gray:hover {\n    opacity: 0.5;\n    cursor: default;\n    border: solid var(--gray-300) 1px;\n}\n\n.pgnvjs div.nagMenu a,\n.pgnvjs .nagMenu i {\n    text-decoration: none;\n    font-style: unset;\n    /*text-align: center;*/\n}\n\n.pgnvjs div.nagMove,\n.pgnvjs div.nagObservation,\n.pgnvjs div.nagPosition {\n    display: flex;\n    flex-direction: column;\n    flex-basis: 33.3%;\n    /*text-align: left;*/\n    flex-wrap: wrap;\n}\n.pgnvjs .nagMove i,\n.pgnvjs .nagPosition i,\n.pgnvjs .nagObservation i {\n    display: flex;\n    cursor: pointer;\n    align-items: center;\n    justify-content: left;\n    margin: var(--space-xss);\n}\n\n.pgnvjs .nagMove i::before,\n.pgnvjs .nagPosition i::before,\n.pgnvjs .nagObservation i::before {\n    content: attr(data-symbol);\n    font-style: normal;\n    width: var(--space-md);\n    justify-content: center;\n    align-items: center;\n    /*width: 30px;*/\n}\n\n.pgnvjs a.active i::before {\n    background: var(--gray-700) !important;\n    color: var(--gray-100) !important;\n}\n\n.pgnvjs a.active i::before i:hover {\n    background: var(--gray-100) !important;\n    color: var(--gray-700) !important;\n}\n\n.pgnvjs .nagMove i:hover,\n.pgnvjs .nagPosition i:hover,\n.pgnvjs .nagObservation i:hover {\n    background: var(--gray-700);\n    color: var(--gray-100);\n}\n\n.pgnvjs textarea.textpgn {\n    padding: 2px;\n    border: 1px solid grey;\n    width: 96%;\n    height: 100px;\n    font-family: monospace;\n}\n\n.ui-widget {\n    font-size: 1em;\n}\n\n.pgnvjs div.commentRadio label {\n    display: inline;\n}\n.pgnvjs div.comment > textarea.comment {\n    font-family: monospace;\n    width: 96%;\n    height: 50px;\n    padding: 2px;\n}\n\n.pgnvjs .moves.inline .filler {\n    display: none;\n}\n\n.pgnvjs .moves.inline move-number.filler {\n    display: inline;\n}\n\n.pgnvjs .moves.list {\n    display: flex;\n    flex-flow: row wrap;\n    align-content: flex-start;\n    overflow-x: hidden;\n    width: 100%;\n}\n\n.pgnvjs .moves.list > .result {\n    display: flex;\n    flex: 0 0 100%;\n    justify-content: center;\n    margin-top: 0.5em; /* Add some spacing from moves above */\n    white-space: nowrap;\n}\n\n.pgnvjs .moves.list > move,\n.pgnvjs .moves.list .move.filler {\n    flex: 0 0 35%;\n    display: flex;\n    /*padding: 0 0.3em;*/\n    white-space: nowrap;\n}\n\n.pgnvjs .moves > move,\n.result {\n    display: inline-block;\n}\n\n.pgnvjs .variation,\n.pgnvjs .variation > .moveNumber,\n.pgnvjs .variation > move.var {\n    white-space: normal;\n}\n\n.pgnvjs .moves.list > move-number {\n    flex: 0 0 15%;\n    justify-content: center;\n    display: flex;\n    border-right: 1px solid var(--gray-300);\n    background: var(--gray-100);\n}\n\n.pgnvjs .moves a {\n    text-decoration: underline;\n}\n\n.pgnvjs .moves move san.yellow {\n    /*background-color: rgba(255, 255, 153, 1.0);*/\n    color: var(--gray-800);\n    background-color: var(--highlight);\n}\n\n.pgnvjs .moves move san {\n    text-decoration: none;\n    padding: 0 0.2rem;\n}\n\n.pgnvjs .moves move san:hover {\n    /*border: 1px yellow dotted;*/\n    background-color: var(--highlight);\n    cursor: crosshair;\n}\n\n.pgnvjs .moves move nag::before {\n    content: attr(data-value);\n}\n\n.pgnvjs .moves move nag.hideaddcontent::before {\n    content: \"\";\n}\n\n/*.pgnvjs .moves move nag[data-value=\"$11\"]::before {*/\n/*    content: \"=\";*/\n/*}*/\n\n.pgnvjs .moves,\n.pgnvjs select.games {\n    color: black;\n    font-weight: 700;\n    line-height: normal;\n}\n\n.pgnvjs .moves .variation move.var,\n.pgnvjs .moves .variation move-number {\n    font-size: 97%;\n    font-weight: 500;\n}\n\n.pgnvjs .moves .variation .variation move.var,\n.pgnvjs .moves .variation .variation move-number {\n    font-size: 95%;\n    font-weight: 300;\n}\n\n.pgnvjs.moves .variation {\n    display: inline-block;\n    margin: 0 6px;\n}\n\n.pgnvjs .moves.list .variations {\n    flex: 0 0 100%;\n    flex-wrap: wrap;\n    display: flex;\n    margin: 0;\n    background: var(--gray-100);\n    border-top: 1px solid var(--gray-300);\n    border-bottom: 1px solid var(--gray-300);\n}\n\n.pgnvjs .moves.list .variation {\n    flex: 0 0 90%;\n    display: block;\n    margin: 0 20px;\n}\n\n.pgnvjs .moves .variation:before {\n    content: \" ( \";\n}\n\n.pgnvjs .moves .variation .variation:before {\n    content: \" ( \";\n}\n\n.pgnvjs .moves .variation .variation {\n    margin: 0 6px;\n}\n\n.pgnvjs .moves .variation .variation:after {\n    content: \" ) \";\n}\n\n.pgnvjs .moves .variation:after {\n    content: \" ) \";\n}\n\n.pgnvjs .moves .comment,\n.pgnvjs .moves.list > .variation > .comment {\n    color: var(--gray-600);\n    font-weight: 500;\n    display: inline;\n}\n\n.pgnvjs .moves.list > .comment {\n    flex: 0 0 100%;\n    display: flex;\n    background: var(--gray-100);\n    border-top: 1px solid var(--gray-300);\n    border-bottom: 1px solid var(--gray-300);\n    /* padding: 5px; */\n}\n\n.pgnvjs .moves move .comment.timeTiny {\n    font-weight: 300;\n    font-size: 60%;\n}\n\n.pgnvjs .moves move .comment.timeLarge {\n}\n\n.pgnvjs .moves move .timeNormal {\n    font-weight: 400;\n    font-size: 80%;\n}\n\n/*\npuzzle mode\n*/\n\n.pgnvjs textarea.hints {\n    grid-row: 6/6;\n    display: flex;\n    font-family: monospace;\n    width: 96%;\n    height: 100px;\n    padding: 2px;\n}\n\n/**\n  CHESSGROUND changes.\n  */\n\n.pgnvjs .cg-wrap coords.ranks {\n    top: -8px;\n    right: -4px;\n    left: initial;\n}\n\n/*\n.cg-wrap coords {\n    font-size: 16px;\n}\n*/\n\n.pgnvjs .cg-wrap coords.files {\n    bottom: 2px;\n    left: 16px;\n    /*text-transform: initial;*/\n}\n\n.pgnvjs .cg-wrap.orientation-white coords.ranks coord:nth-child(2n),\n.pgnvjs .cg-wrap.orientation-white coords.files coord:nth-child(2n),\n.pgnvjs .cg-wrap.orientation-black coords.ranks coord:nth-child(2n + 1),\n.pgnvjs .cg-wrap.orientation-black coords.files coord:nth-child(2n + 1) {\n    color: initial;\n}\n\n.pgnvjs .cg-wrap.orientation-black coords.ranks coord:nth-child(2n),\n.pgnvjs .cg-wrap.orientation-black coords.files coord:nth-child(2n),\n.pgnvjs .cg-wrap.orientation-white coords.ranks coord:nth-child(2n + 1),\n.pgnvjs .cg-wrap.orientation-white coords.files coord:nth-child(2n + 1) {\n    color: initial;\n}\n\n/* colorMarker */\n\n.pgnvjs .colorMarker {\n    width: 20px;\n    height: 20px;\n    border-color: black;\n    border-width: 2px;\n    border-style: double;\n    margin-left: 50px;\n    align-self: center;\n    box-shadow:\n        0 4px 8px 0 rgba(0, 0, 0, 0.2),\n        0 6px 20px 0 rgba(0, 0, 0, 0.19);\n}\n\n.pgnvjs .colorMarker.circle {\n    border-radius: 20px;\n}\n\n.pgnvjs .colorMarker.circle-big {\n    border-radius: 40px;\n    width: 40px;\n    height: 40px;\n}\n\n.pgnvjs .colorMarker.circle-small {\n    border-radius: 10px;\n    width: 10px;\n    height: 10px;\n}\n\n.pgnvjs .colorMarker.cm-black {\n    background-color: black;\n}\n\n.pgnvjs .colorMarker.cm-white {\n    background-color: white;\n}\n\n.pgnvjs .colorMarker.cm-big {\n    width: 40px;\n    height: 40px;\n}\n\n.pgnvjs .colorMarker.cm-small {\n    width: 10px;\n    height: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
